import { render } from "./SelectorOpciones.vue?vue&type=template&id=dd33f0a8&scoped=true"
import script from "./SelectorOpciones.vue?vue&type=script&lang=js"
export * from "./SelectorOpciones.vue?vue&type=script&lang=js"

import "./SelectorOpciones.vue?vue&type=style&index=0&id=dd33f0a8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dd33f0a8"]])

export default __exports__